
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function StorySection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="story" ref={sectionRef} className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div className={`space-y-8 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <h2 
              className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#2A2A2A] leading-tight"
              style={{ fontFamily: 'Playfair Display, Noto Serif SC, serif' }}
            >
              {t('story_title')}
              <br />
              <span className="text-lg sm:text-xl lg:text-2xl text-[#A6A6A6]">{t('story_subtitle')}</span>
            </h2>
            
            <div className="space-y-6">
              <p 
                className="text-xs sm:text-sm lg:text-base text-[#2A2A2A] leading-relaxed"
                style={{ fontFamily: 'Inter, Noto Sans SC, sans-serif' }}
              >
                {t('story_description_1')}
              </p>
              
              <p 
                className="text-xs sm:text-sm lg:text-base text-[#2A2A2A] leading-relaxed"
                style={{ fontFamily: 'Inter, Noto Sans SC, sans-serif' }}
              >
                {t('story_description_2')}
              </p>
              
              <blockquote className="border-l-4 border-[#F5F1E6] pl-6 py-4 bg-[#F5F1E6]/20">
                <p 
                  className="text-sm sm:text-base lg:text-lg font-medium text-[#2A2A2A] italic"
                  style={{ fontFamily: 'Playfair Display, Noto Serif SC, serif' }}
                >
                  "{t('story_quote')}"
                </p>
              </blockquote>
            </div>
          </div>

          {/* Image */}
          <div className={`transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/72dc45cbb1188319b6a9d2eec91aea68.jfif"
                alt="神话灵鹿插画"
                className="w-full h-auto rounded-lg shadow-lg object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white/20 to-transparent rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
